import { createStyles } from '@mantine/core';

const useStyles = createStyles(theme => ({
  baseHeader: {
    width: '100%',
    background: theme.colors.gray[0],
    padding: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,
    borderBottom: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: 0,
    alignItems: 'center',
    gap: theme.spacing.sm,
    whiteSpace: 'nowrap',
  },
  headerWithExpectations: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr min-content min-content',
    gridTemplateAreas: `
        'title manageTracking clear download'
        'filters filters filters filters'
    `,
    [theme.fn.smallerThan('md')]: {
      gridTemplateColumns: 'max-content auto min-content min-content',
      gridTemplateAreas: `
        'title manageTracking clear download'
        'filters filters filters filters'
        `,
    },
    [theme.fn.smallerThan('sm')]: {
      gridTemplateColumns: 'auto auto',
      gridTemplateAreas: `
        'title clear'
        'manageTracking manageTracking'
        'filters filters'
        `,
    },
  },
  titleSection: {
    gridArea: 'title',
  },
  title: {
    fontSize: theme.headings.sizes.h1.fontSize,
    lineHeight: theme.headings.sizes.h1.lineHeight,
    [theme.fn.smallerThan('md')]: {
      fontSize: theme.headings.sizes.h2.fontSize,
      lineHeight: theme.headings.sizes.h2.lineHeight,
    },
    [theme.fn.smallerThan('sm')]: {
      fontSize: theme.headings.sizes.h3.fontSize,
      lineHeight: theme.headings.sizes.h3.lineHeight,
    },
  },
  manageTracking: {
    gridArea: 'manageTracking',
    minHeight: '36px',
    height: '100%',
  },
  manageTrackingText: {
    whiteSpace: 'normal',
    textAlign: 'center',
  },
  clear: {
    gridArea: 'clear',
    [theme.fn.smallerThan('sm')]: {
      justifySelf: 'end',
    },
  },
  download: {
    gridArea: 'download',
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },
  filters: {
    gridArea: 'filters',
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gridTemplateAreas: `
    'dateRangeFilter utilizationFilter athletesFilter packagesFilter eventTypesFilter'
    'groupByAthlete groupByPackage None None None'
    `,
    gap: theme.spacing.xs,
    [theme.fn.smallerThan('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridTemplateAreas: `
        'dateRangeFilter dateRangeFilter'
        'utilizationFilter athletesFilter'
        'packagesFilter eventTypesFilter'
        'groupByAthlete groupByPackage'
      `,
      gap: theme.spacing.sm,
    },
    [theme.fn.smallerThan('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridTemplateAreas: `
        'title clear'
        'dateRangeFilter dateRangeFilter'
        'utilizationFilter utilizationFilter'
        'athletesFilter athletesFilter'
        'packagesFilter packagesFilter'
        'eventTypesFilter eventTypesFilter'
        'groupByAthlete groupByPackage'
      `,
      gap: theme.spacing.sm,
    },
  },
  dateRangeFilter: {
    gridArea: 'dateRangeFilter',
  },
  utilizationFilter: {
    gridArea: 'utilizationFilter',
  },
  athletesFilter: {
    gridArea: 'athletesFilter',
  },
  packagesFilter: {
    gridArea: 'packagesFilter',
  },
  eventTypesFilter: {
    gridArea: 'eventTypesFilter',
  },
  groupByAthlete: {
    gridArea: 'groupByAthlete',
  },
  groupByPackage: {
    gridArea: 'groupByPackage',
  },
}));

export default useStyles;
